import React from 'react';
import { useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import NavbarText from 'react-bootstrap/esm/NavbarText';
import { Container } from 'react-bootstrap';
import Button from '../UI/button';
import SendInvitationModal from '../modals/invitations/send-invitation-modal';

function TripsInvitationsNavBar({ onAddTripStateChange, onSortByStateChange }: any) {
  const [showSendInvitationModal, setShowSendInvitationModal] = useState(false);

  const handleAddTrip = () => {
    onAddTripStateChange(true);
  };

  const handleSortBy = () => {
    onSortByStateChange(true);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Searching...');
  };

  const [addTrip, setAddTrip] = useState(false);

  return (
    <Navbar className='top-navbar-page w-100 justify-content-between p-0' style={{margin: '32px 0 24px'}}>
        <Nav className='flex-grow-1'>
          <Form onSubmit={handleSubmit} className='position-relative'>
            <Form.Control
              type='text'
              placeholder='Search'
              className='mr-sm-2 rounded-pill ps-3'
              style={{width: '280px', maxWidth: '100%' }}
            />
            <Button type='submit' variant='transparent' className='position-absolute top-50 translate-middle-y' style={{right: '10px'}}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5">
                <path fillRule="evenodd" d="M5.99231 10.9869C8.75002 10.9869 10.9856 8.75128 10.9856 5.99346C10.9856 3.23565 8.75002 1 5.99231 1C3.23459 1 0.999023 3.23565 0.999023 5.99346C0.999023 8.75128 3.23459 10.9869 5.99231 10.9869Z" stroke="#777777" strokeWidth="1.5" strokeLinejoin="round"/>
                <path d="M9.86133 9.86142L12.9998 13" stroke="#777777" strokeWidth="1.5" strokeLinejoin="round"/>
                </g>
              </svg>
            </Button>
          </Form>
        </Nav>
        <Nav className='flex-grow-1'>
          <NavbarText className='text-dark p-0'>
            <h2 style={{fontSize: '28px', lineHeight: '38px'}}>Accept and Send Invitations</h2>
          </NavbarText>
        </Nav>
        <Nav className='flex-grow-1 d-flex justify-content-end'>
          <Button variant='primary' onClick={() => setShowSendInvitationModal(true)}>
            Send Invitation
          </Button>
        </Nav>
        <SendInvitationModal show={showSendInvitationModal} handleClose={() => setShowSendInvitationModal(false)} />
    </Navbar>
  );
}
export default TripsInvitationsNavBar;
